import AdmanAlert from '../Alert';
import { StyledBlock, StyledBodyWrapper } from './styled';

type Props = {
  testId?: string;
  text: string;
};

const ErrorBlock = ({ testId, text }: Props): JSX.Element => (
  <StyledBodyWrapper data-testid={testId}>
    <StyledBlock>
      <AdmanAlert type={'error'} text={text} />
    </StyledBlock>
  </StyledBodyWrapper>
);

export default ErrorBlock;
